<template>
  <div class="validate__header">
    <span>Validation email</span>
  </div>
  <div class="validate__content">
    <div
      v-if="isLoading"
      class="loader"
    ></div>
    <h1>{{ contentText }}</h1>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ValidateEmail',
  data() {
    return {
      isLoading: true,
      isErrored: false,
      token: '',
    }
  },
  async created() {
    this.token = this.$route.query.token;
    await this.validateEmail();
  },
  computed: {
    contentText() {
      if (this.isLoading) {
        return 'Email en court de validation';
      }
      if (this.isErrored) {
        return "Nous n'avons pas pu valider votre email veuillez ré-essayer de créer un compte ou de vous inscrire via google.";
      }

      return "Votre email a été validé ! Vous pouvez maintenant vous connecter sur Nohyia ! Profitez bien."
    }
  },
  methods: {
    validateEmail() {
      axios
        .post(`https://nohyia-fc0806dfbe46.herokuapp.com/auth/validateEmail/${this.token}`)
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.isErrored = true;
        });
    }
  }
}
</script>

<style lang="scss">
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.validate {
  &__header {
    display: flex;
    align-items: flex-end;
    height: 180px;
    padding: 30px 50px;
    background-color: black;
    color: white;
    font-size: 40px;
    font-weight: bold;
    position: relative;
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
  }
}
</style>